import React from 'react'
import { ChevronLeft } from 'lucide-react'
import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
} from '@/features/shadcn/ui/sidebar'

export interface SidebarDrillDownPanelProps {
  title: string
  onBack: () => void
  children: React.ReactNode
}

const SidebarDrillDownPanel: React.FC<SidebarDrillDownPanelProps> = ({ title, onBack, children }) => (
  <SidebarGroup className="tw-flex-1 tw-min-h-0">
    <SidebarGroupLabel className="tw-h-auto tw-flex tw-flex-col tw-items-start tw-gap-1 tw-py-2">
      <button
        type="button"
        className="tw-inline-flex tw-w-full tw-items-center tw-mb-3 tw-justify-start tw-gap-1 tw-text-xs tw-font-bold tw-text-slate-600 hover:tw-text-slate-900"
        onClick={onBack}
      >
        <ChevronLeft className="tw-h-3 tw-w-3" />
        Back
      </button>
      <span className="tw-w-full tw-text-left tw-text-sm tw-font-bold tw-text-slate-700">{title}</span>
    </SidebarGroupLabel>
    <div className="tw-px-4 tw-pb-2">
      <div className="tw-border-t tw-border-sidebar-border" />
    </div>
    <SidebarGroupContent className="tw-flex-1 tw-min-h-0 tw-flex tw-flex-col">{children}</SidebarGroupContent>
  </SidebarGroup>
)

export default SidebarDrillDownPanel
